import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme, "catalogue");

  return {
    id: id,
    elements: [
      {
        type: "text",
        id: "h6KuujC44K",
        width: 44.3,
        height: 40,
        left: 881.85,
        top: 26.91,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: left;"><span style="font-size: 1.02px;font-family: 微软雅黑;">PPT</span><span style="font-size: 1.02px;font-family: 微软雅黑;">模板</span><span style="font-size: 1.02px;font-family: 微软雅黑;">http://www.1ppt.com/moban/</span><span style="font-size: 1.02px;font-family: 微软雅黑;">&nbsp;</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "IIqJ93GTcb",
        width: 285.72570917759236,
        height: 99,
        left: 143.26056019070322,
        top: 248.74764004767582,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: justify;"><span style="font-size: 44px;"><span style="font-family: 阿里巴巴普惠体;">目录</span></span></p><p style="text-align: justify;"><span style="font-size: 30px;"><span style="font-family: 阿里巴巴普惠体;">CATALOG</span></span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "efGWo-6V0V",
        width: 181.15087008343266,
        height: 40,
        left: 34.17,
        top: 31.77,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style=""><strong><span style="font-size: 20px;"><span style="font-family: STSong;"><span style="color: rgba(70,185,246,1);">LOGO&nbsp;&nbsp;</span></span></span></strong></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "GgRkDNGPLF",
        left: 112.78752085816446,
        top: 31.77,
        width: 117.28247914183555,
        height: 40,
        content:
          '<p style="text-align: center;"><span style="font-family: STSong;"><span style="color: rgba(51,51,51,1);">XX公司</span></span></p>',
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        vertical: false,
        lineHeight: 1,
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 468.38435695538055,
        top: 200.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
    ],

    background,
  };
}
